import localRequest from './localRequest';

const logger = function (type, data) {
  //   localRequest({
  //   method: 'post',
  //   url: '/logger',
  //   data: { type:type, data:data }
  // })
};

export default logger;
